import React, { PropsWithChildren } from 'react';
import { FilterSecondaryButton } from './FiltersSecondary.style';

export interface FilterSecondaryPropsType extends PropsWithChildren {
    isActive?: boolean;
    isDisabled?: boolean;
    onClick?: () => void;
    title?: string;
    dataTestFilterKey?: string;
    filterType?: 'default' | 'badge' | 'dropdown' | 'bet-builder';
}

export const FilterSecondary = ({
    children,
    isActive,
    isDisabled,
    onClick,
    title,
    dataTestFilterKey,
    filterType = 'default',
}: FilterSecondaryPropsType): JSX.Element => {
    return (
        <FilterSecondaryButton
            type='button'
            isActive={isActive}
            isDisabled={isDisabled}
            disabled={isDisabled}
            onClick={onClick}
            title={title}
            data-is-active={isActive}
            data-test-filter-key={dataTestFilterKey}
            filterType={filterType}
        >
            {children}
        </FilterSecondaryButton>
    );
};
